import { TInvoiceStatus } from '../schemas';

export const INVOICE_STATUS_TO_COLOR: Record<TInvoiceStatus, string> = {
    CREATED: '#738291',
    WAITING_FOR_PAYMENT: '#215dd6',
    UPCOMING_PAYMENT: '#e6b800',
    OVERDUE: '#ff961c',
    MONTH_OVERDUE: '#ff5555',
    PAID: '#00a720',
    CANCELED: '#738291',
};
